import { Component, Injector, Input } from '@angular/core';
import { AppComponentBase } from '../../app-component-base';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent extends AppComponentBase {
  @Input() title!: string;
  @Input() items!: any[];
  @Input() active_item!: string;

  @Input() helperRoute!: string

  constructor(
    injector: Injector,
  ) {
    super(injector)
  }
}
